import React from 'react';
import { Modal } from '@routific/hive';
import { Calendar } from 'antd';
import { useTranslation } from 'react-i18next';
import { Moment } from 'moment';

interface DuplicateDateModalProps {
  visible: boolean;
  selectedDate: Moment | undefined;
  isSubmitting: boolean;
  routeCount: number;
  onSelectDate: (date: Moment) => void;
  onSubmit: () => void;
  onCancel: () => void;
}

const DuplicateDateModal: React.FC<DuplicateDateModalProps> = ({
  visible,
  selectedDate,
  isSubmitting,
  routeCount,
  onSelectDate,
  onSubmit,
  onCancel,
}) => {
  const { t } = useTranslation('components');

  return (
    <Modal
      size="small"
      centered
      visible={visible}
      onCancel={onCancel}
      maskClosable={false}
      title={t('duplicateRoutes.title', { count: routeCount })}
      onOk={onSubmit}
      okText={isSubmitting ? t('duplicateRoutes.copying', { count: routeCount }) : t('duplicateRoutes.copy', { count: routeCount })}
      okButtonProps={{ loading: isSubmitting }}
    >
      <Calendar
        fullscreen={false}
        onSelect={onSelectDate}
        value={selectedDate}
      />
    </Modal>
  );
};

export default DuplicateDateModal;
